import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';
import { Button, CurrencyFormat } from '@lt/components';

import HotelRating from 'src/components/HotelRating';
import ReviewsList from './ReviewsList';

const baseCls = 'lt-hotel-reviews';

const ReviewsDesktop = ({ hotelName, hotelLink, price }) => {
  const { t } = useTranslation();

  return (
    <div className={baseCls}>
      <ReviewsHeading>
        <StyledH2>
          {t('hotel.reviews.title')} {hotelName}
        </StyledH2>
        <Link href={hotelLink}>
          <PriceButton primary>
            {t('hotel.reviews.selectTour')}
            {price ? <CurrencyFormat prefix=" от " value={price} /> : null}
          </PriceButton>
        </Link>
      </ReviewsHeading>
      <div className={`${baseCls}__row`}>
        <div className={`${baseCls}__list`}>
          <div className={`${baseCls}__items`}>
            <ReviewsList />
          </div>
        </div>
        <StyledRating>
          <HotelRating />
        </StyledRating>
      </div>
    </div>
  );
};

const StyledH2 = styled.h2`
  color: var(--black);
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;
`;

const ReviewsHeading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

const PriceButton = styled(Button)`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  padding: 12px 16px;
  height: auto;
  width: auto;
`;

const Link = styled.a`
  text-decoration: none;
`;

const StyledRating = styled.div`
  width: 332px;
  margin-left: 8px;
`;

ReviewsDesktop.propTypes = {
  hotelName: PropTypes.string.isRequired,
};

export default ReviewsDesktop;
